<div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <h4 class="page-title">Duplicate Invoice</h4>
      </div>
    </div>
  </div>
  <app-invoice-form
    [form]="form"
    [buttonText]="buttonText"
    [errorProvider]="errorProvider"
    [submittingProvider]="submittingProvider"
    (clicked)="duplicateInvoice()"
  ></app-invoice-form>
  